import { render, staticRenderFns } from "./OrderableActionDisableTaxes.vue?vue&type=template&id=4abb4fd5&"
import script from "./OrderableActionDisableTaxes.vue?vue&type=script&lang=ts&"
export * from "./OrderableActionDisableTaxes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports